// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/analysis/v1/analysis.proto" (package "c1.api.analysis.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.analysis.v1.AnalysisServiceGetRequest
 */
export interface AnalysisServiceGetRequest {
    /**
     * @generated from protobuf field: string analysis_id = 1
     */
    analysisId: string;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.AnalysisServiceGetResponse
 */
export interface AnalysisServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.analysis.v1.Analysis analysis = 1
     */
    analysis?: Analysis;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.Analysis
 */
export interface Analysis {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string app_id = 5
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 6
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 7
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.analysis.v1.AnalysisState state = 8
     */
    state: AnalysisState;
    /**
     * @generated from protobuf field: repeated c1.api.analysis.v1.Outcome outcomes = 9
     */
    outcomes: Outcome[];
}
/**
 * @generated from protobuf message c1.api.analysis.v1.Outcome
 */
export interface Outcome {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.analysis.v1.OutcomeState state = 4
     */
    state: OutcomeState;
    /**
     * @generated from protobuf field: google.protobuf.Any outcome = 5
     */
    outcome?: Any;
    /**
     * @generated from protobuf field: string error = 6
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.Relevance
 */
export interface Relevance {
    /**
     * @generated from protobuf field: double relevance_score = 1
     */
    relevanceScore: number;
    /**
     * @generated from protobuf field: int64 num_in_pop = 2
     */
    numInPop: number;
    /**
     * @generated from protobuf field: int64 num_in_group = 3
     */
    numInGroup: number;
    /**
     * @generated from protobuf field: int64 pop_with_access = 4
     */
    popWithAccess: number;
    /**
     * @generated from protobuf field: int64 group_with_access = 5
     */
    groupWithAccess: number;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.UserProp
 */
export interface UserProp {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: string value = 2
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.UserPropData
 */
export interface UserPropData {
    /**
     * @generated from protobuf field: c1.api.analysis.v1.UserProp user_prop = 2
     */
    userProp?: UserProp;
    /**
     * @generated from protobuf field: c1.api.analysis.v1.Relevance relevance = 3
     */
    relevance?: Relevance;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.UserPropOutcome
 */
export interface UserPropOutcome {
    /**
     * @generated from protobuf field: bool is_outcome = 1
     */
    isOutcome: boolean;
    /**
     * @generated from protobuf field: c1.api.analysis.v1.UserPropData input = 2
     */
    input?: UserPropData;
    /**
     * @generated from protobuf field: repeated c1.api.analysis.v1.UserPropData most_relevant = 3
     */
    mostRelevant: UserPropData[];
}
/**
 * @generated from protobuf message c1.api.analysis.v1.GlobalOutcome
 */
export interface GlobalOutcome {
    /**
     * @generated from protobuf field: bool is_outcome = 1
     */
    isOutcome: boolean;
    /**
     * @generated from protobuf field: int64 num_in_pop = 2
     */
    numInPop: number;
    /**
     * @generated from protobuf field: int64 pop_with_access = 3
     */
    popWithAccess: number;
    /**
     * @generated from protobuf field: int64 num_in_app = 4
     */
    numInApp: number;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.AccountOutcome
 */
export interface AccountOutcome {
    /**
     * @generated from protobuf field: bool is_outcome = 1
     */
    isOutcome: boolean;
    /**
     * @generated from protobuf field: int64 num_in_pop = 2
     */
    numInPop: number;
    /**
     * @generated from protobuf field: int64 pop_with_access = 3
     */
    popWithAccess: number;
    /**
     * @generated from protobuf field: int64 num_in_app = 4
     */
    numInApp: number;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.ManagerData
 */
export interface ManagerData {
    /**
     * @generated from protobuf field: string manager_id = 1
     */
    managerId: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.analysis.v1.Relevance relevance = 3
     */
    relevance?: Relevance;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.ManagerOutcome
 */
export interface ManagerOutcome {
    /**
     * @generated from protobuf field: bool is_outcome = 1
     */
    isOutcome: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.analysis.v1.ManagerData managers = 2
     */
    managers: ManagerData[];
    /**
     * @generated from protobuf field: repeated c1.api.analysis.v1.ManagerData most_relevant = 3
     */
    mostRelevant: ManagerData[];
}
/**
 * @generated from protobuf message c1.api.analysis.v1.AccessConflictOutcome
 */
export interface AccessConflictOutcome {
    /**
     * @generated from protobuf field: bool is_outcome = 1
     */
    isOutcome: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.analysis.v1.AccessConflictData monitors = 2
     */
    monitors: AccessConflictData[];
}
/**
 * @generated from protobuf message c1.api.analysis.v1.AccessConflictData
 */
export interface AccessConflictData {
    /**
     * @generated from protobuf field: string monitor_id = 1
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string monitor_display_name = 2
     */
    monitorDisplayName: string;
}
/**
 * @generated from protobuf enum c1.api.analysis.v1.AnalysisState
 */
export enum AnalysisState {
    /**
     * @generated from protobuf enum value: ANALYSIS_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ANALYSIS_STATE_CREATED = 1;
     */
    CREATED = 1,
    /**
     * @generated from protobuf enum value: ANALYSIS_STATE_STARTED = 2;
     */
    STARTED = 2,
    /**
     * @generated from protobuf enum value: ANALYSIS_STATE_DONE = 3;
     */
    DONE = 3,
    /**
     * @generated from protobuf enum value: ANALYSIS_STATE_ERROR = 4;
     */
    ERROR = 4
}
/**
 * @generated from protobuf enum c1.api.analysis.v1.OutcomeState
 */
export enum OutcomeState {
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_CREATED = 1;
     */
    CREATED = 1,
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_STARTED = 2;
     */
    STARTED = 2,
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_DONE = 3;
     */
    DONE = 3,
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_NA = 4;
     */
    NA = 4,
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_ERROR = 5;
     */
    ERROR = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class AnalysisServiceGetRequest$Type extends MessageType<AnalysisServiceGetRequest> {
    constructor() {
        super("c1.api.analysis.v1.AnalysisServiceGetRequest", [
            { no: 1, name: "analysis_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AnalysisServiceGetRequest>): AnalysisServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.analysisId = "";
        if (value !== undefined)
            reflectionMergePartial<AnalysisServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AnalysisServiceGetRequest): AnalysisServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string analysis_id */ 1:
                    message.analysisId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AnalysisServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string analysis_id = 1; */
        if (message.analysisId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.analysisId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.AnalysisServiceGetRequest
 */
export const AnalysisServiceGetRequest = new AnalysisServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnalysisServiceGetResponse$Type extends MessageType<AnalysisServiceGetResponse> {
    constructor() {
        super("c1.api.analysis.v1.AnalysisServiceGetResponse", [
            { no: 1, name: "analysis", kind: "message", T: () => Analysis }
        ]);
    }
    create(value?: PartialMessage<AnalysisServiceGetResponse>): AnalysisServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AnalysisServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AnalysisServiceGetResponse): AnalysisServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.analysis.v1.Analysis analysis */ 1:
                    message.analysis = Analysis.internalBinaryRead(reader, reader.uint32(), options, message.analysis);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AnalysisServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.analysis.v1.Analysis analysis = 1; */
        if (message.analysis)
            Analysis.internalBinaryWrite(message.analysis, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.AnalysisServiceGetResponse
 */
export const AnalysisServiceGetResponse = new AnalysisServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Analysis$Type extends MessageType<Analysis> {
    constructor() {
        super("c1.api.analysis.v1.Analysis", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "state", kind: "enum", T: () => ["c1.api.analysis.v1.AnalysisState", AnalysisState, "ANALYSIS_STATE_"] },
            { no: 9, name: "outcomes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Outcome }
        ]);
    }
    create(value?: PartialMessage<Analysis>): Analysis {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.appId = "";
        message.appUserId = "";
        message.appEntitlementId = "";
        message.state = 0;
        message.outcomes = [];
        if (value !== undefined)
            reflectionMergePartial<Analysis>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Analysis): Analysis {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 4:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string app_id */ 5:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 6:
                    message.appUserId = reader.string();
                    break;
                case /* string app_entitlement_id */ 7:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.analysis.v1.AnalysisState state */ 8:
                    message.state = reader.int32();
                    break;
                case /* repeated c1.api.analysis.v1.Outcome outcomes */ 9:
                    message.outcomes.push(Outcome.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Analysis, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 4; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 5; */
        if (message.appId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 6; */
        if (message.appUserId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.appUserId);
        /* string app_entitlement_id = 7; */
        if (message.appEntitlementId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.analysis.v1.AnalysisState state = 8; */
        if (message.state !== 0)
            writer.tag(8, WireType.Varint).int32(message.state);
        /* repeated c1.api.analysis.v1.Outcome outcomes = 9; */
        for (let i = 0; i < message.outcomes.length; i++)
            Outcome.internalBinaryWrite(message.outcomes[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.Analysis
 */
export const Analysis = new Analysis$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Outcome$Type extends MessageType<Outcome> {
    constructor() {
        super("c1.api.analysis.v1.Outcome", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.analysis.v1.OutcomeState", OutcomeState, "OUTCOME_STATE_"] },
            { no: 5, name: "outcome", kind: "message", T: () => Any },
            { no: 6, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Outcome>): Outcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.state = 0;
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<Outcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Outcome): Outcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* c1.api.analysis.v1.OutcomeState state */ 4:
                    message.state = reader.int32();
                    break;
                case /* google.protobuf.Any outcome */ 5:
                    message.outcome = Any.internalBinaryRead(reader, reader.uint32(), options, message.outcome);
                    break;
                case /* string error */ 6:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Outcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.analysis.v1.OutcomeState state = 4; */
        if (message.state !== 0)
            writer.tag(4, WireType.Varint).int32(message.state);
        /* google.protobuf.Any outcome = 5; */
        if (message.outcome)
            Any.internalBinaryWrite(message.outcome, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string error = 6; */
        if (message.error !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.Outcome
 */
export const Outcome = new Outcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Relevance$Type extends MessageType<Relevance> {
    constructor() {
        super("c1.api.analysis.v1.Relevance", [
            { no: 1, name: "relevance_score", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "num_in_pop", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "num_in_group", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "pop_with_access", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "group_with_access", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<Relevance>): Relevance {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.relevanceScore = 0;
        message.numInPop = 0;
        message.numInGroup = 0;
        message.popWithAccess = 0;
        message.groupWithAccess = 0;
        if (value !== undefined)
            reflectionMergePartial<Relevance>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Relevance): Relevance {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double relevance_score */ 1:
                    message.relevanceScore = reader.double();
                    break;
                case /* int64 num_in_pop */ 2:
                    message.numInPop = reader.int64().toNumber();
                    break;
                case /* int64 num_in_group */ 3:
                    message.numInGroup = reader.int64().toNumber();
                    break;
                case /* int64 pop_with_access */ 4:
                    message.popWithAccess = reader.int64().toNumber();
                    break;
                case /* int64 group_with_access */ 5:
                    message.groupWithAccess = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Relevance, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* double relevance_score = 1; */
        if (message.relevanceScore !== 0)
            writer.tag(1, WireType.Bit64).double(message.relevanceScore);
        /* int64 num_in_pop = 2; */
        if (message.numInPop !== 0)
            writer.tag(2, WireType.Varint).int64(message.numInPop);
        /* int64 num_in_group = 3; */
        if (message.numInGroup !== 0)
            writer.tag(3, WireType.Varint).int64(message.numInGroup);
        /* int64 pop_with_access = 4; */
        if (message.popWithAccess !== 0)
            writer.tag(4, WireType.Varint).int64(message.popWithAccess);
        /* int64 group_with_access = 5; */
        if (message.groupWithAccess !== 0)
            writer.tag(5, WireType.Varint).int64(message.groupWithAccess);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.Relevance
 */
export const Relevance = new Relevance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProp$Type extends MessageType<UserProp> {
    constructor() {
        super("c1.api.analysis.v1.UserProp", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserProp>): UserProp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<UserProp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserProp): UserProp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserProp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.UserProp
 */
export const UserProp = new UserProp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPropData$Type extends MessageType<UserPropData> {
    constructor() {
        super("c1.api.analysis.v1.UserPropData", [
            { no: 2, name: "user_prop", kind: "message", T: () => UserProp },
            { no: 3, name: "relevance", kind: "message", T: () => Relevance }
        ]);
    }
    create(value?: PartialMessage<UserPropData>): UserPropData {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UserPropData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserPropData): UserPropData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.analysis.v1.UserProp user_prop */ 2:
                    message.userProp = UserProp.internalBinaryRead(reader, reader.uint32(), options, message.userProp);
                    break;
                case /* c1.api.analysis.v1.Relevance relevance */ 3:
                    message.relevance = Relevance.internalBinaryRead(reader, reader.uint32(), options, message.relevance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserPropData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.analysis.v1.UserProp user_prop = 2; */
        if (message.userProp)
            UserProp.internalBinaryWrite(message.userProp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.analysis.v1.Relevance relevance = 3; */
        if (message.relevance)
            Relevance.internalBinaryWrite(message.relevance, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.UserPropData
 */
export const UserPropData = new UserPropData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPropOutcome$Type extends MessageType<UserPropOutcome> {
    constructor() {
        super("c1.api.analysis.v1.UserPropOutcome", [
            { no: 1, name: "is_outcome", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "input", kind: "message", T: () => UserPropData },
            { no: 3, name: "most_relevant", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserPropData }
        ]);
    }
    create(value?: PartialMessage<UserPropOutcome>): UserPropOutcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isOutcome = false;
        message.mostRelevant = [];
        if (value !== undefined)
            reflectionMergePartial<UserPropOutcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserPropOutcome): UserPropOutcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_outcome */ 1:
                    message.isOutcome = reader.bool();
                    break;
                case /* c1.api.analysis.v1.UserPropData input */ 2:
                    message.input = UserPropData.internalBinaryRead(reader, reader.uint32(), options, message.input);
                    break;
                case /* repeated c1.api.analysis.v1.UserPropData most_relevant */ 3:
                    message.mostRelevant.push(UserPropData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserPropOutcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_outcome = 1; */
        if (message.isOutcome !== false)
            writer.tag(1, WireType.Varint).bool(message.isOutcome);
        /* c1.api.analysis.v1.UserPropData input = 2; */
        if (message.input)
            UserPropData.internalBinaryWrite(message.input, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.analysis.v1.UserPropData most_relevant = 3; */
        for (let i = 0; i < message.mostRelevant.length; i++)
            UserPropData.internalBinaryWrite(message.mostRelevant[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.UserPropOutcome
 */
export const UserPropOutcome = new UserPropOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GlobalOutcome$Type extends MessageType<GlobalOutcome> {
    constructor() {
        super("c1.api.analysis.v1.GlobalOutcome", [
            { no: 1, name: "is_outcome", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "num_in_pop", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "pop_with_access", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "num_in_app", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<GlobalOutcome>): GlobalOutcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isOutcome = false;
        message.numInPop = 0;
        message.popWithAccess = 0;
        message.numInApp = 0;
        if (value !== undefined)
            reflectionMergePartial<GlobalOutcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GlobalOutcome): GlobalOutcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_outcome */ 1:
                    message.isOutcome = reader.bool();
                    break;
                case /* int64 num_in_pop */ 2:
                    message.numInPop = reader.int64().toNumber();
                    break;
                case /* int64 pop_with_access */ 3:
                    message.popWithAccess = reader.int64().toNumber();
                    break;
                case /* int64 num_in_app */ 4:
                    message.numInApp = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GlobalOutcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_outcome = 1; */
        if (message.isOutcome !== false)
            writer.tag(1, WireType.Varint).bool(message.isOutcome);
        /* int64 num_in_pop = 2; */
        if (message.numInPop !== 0)
            writer.tag(2, WireType.Varint).int64(message.numInPop);
        /* int64 pop_with_access = 3; */
        if (message.popWithAccess !== 0)
            writer.tag(3, WireType.Varint).int64(message.popWithAccess);
        /* int64 num_in_app = 4; */
        if (message.numInApp !== 0)
            writer.tag(4, WireType.Varint).int64(message.numInApp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.GlobalOutcome
 */
export const GlobalOutcome = new GlobalOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountOutcome$Type extends MessageType<AccountOutcome> {
    constructor() {
        super("c1.api.analysis.v1.AccountOutcome", [
            { no: 1, name: "is_outcome", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "num_in_pop", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "pop_with_access", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "num_in_app", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccountOutcome>): AccountOutcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isOutcome = false;
        message.numInPop = 0;
        message.popWithAccess = 0;
        message.numInApp = 0;
        if (value !== undefined)
            reflectionMergePartial<AccountOutcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountOutcome): AccountOutcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_outcome */ 1:
                    message.isOutcome = reader.bool();
                    break;
                case /* int64 num_in_pop */ 2:
                    message.numInPop = reader.int64().toNumber();
                    break;
                case /* int64 pop_with_access */ 3:
                    message.popWithAccess = reader.int64().toNumber();
                    break;
                case /* int64 num_in_app */ 4:
                    message.numInApp = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountOutcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_outcome = 1; */
        if (message.isOutcome !== false)
            writer.tag(1, WireType.Varint).bool(message.isOutcome);
        /* int64 num_in_pop = 2; */
        if (message.numInPop !== 0)
            writer.tag(2, WireType.Varint).int64(message.numInPop);
        /* int64 pop_with_access = 3; */
        if (message.popWithAccess !== 0)
            writer.tag(3, WireType.Varint).int64(message.popWithAccess);
        /* int64 num_in_app = 4; */
        if (message.numInApp !== 0)
            writer.tag(4, WireType.Varint).int64(message.numInApp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.AccountOutcome
 */
export const AccountOutcome = new AccountOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ManagerData$Type extends MessageType<ManagerData> {
    constructor() {
        super("c1.api.analysis.v1.ManagerData", [
            { no: 1, name: "manager_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "relevance", kind: "message", T: () => Relevance }
        ]);
    }
    create(value?: PartialMessage<ManagerData>): ManagerData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.managerId = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<ManagerData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ManagerData): ManagerData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string manager_id */ 1:
                    message.managerId = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.analysis.v1.Relevance relevance */ 3:
                    message.relevance = Relevance.internalBinaryRead(reader, reader.uint32(), options, message.relevance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ManagerData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string manager_id = 1; */
        if (message.managerId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.managerId);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.analysis.v1.Relevance relevance = 3; */
        if (message.relevance)
            Relevance.internalBinaryWrite(message.relevance, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.ManagerData
 */
export const ManagerData = new ManagerData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ManagerOutcome$Type extends MessageType<ManagerOutcome> {
    constructor() {
        super("c1.api.analysis.v1.ManagerOutcome", [
            { no: 1, name: "is_outcome", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "managers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ManagerData },
            { no: 3, name: "most_relevant", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ManagerData }
        ]);
    }
    create(value?: PartialMessage<ManagerOutcome>): ManagerOutcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isOutcome = false;
        message.managers = [];
        message.mostRelevant = [];
        if (value !== undefined)
            reflectionMergePartial<ManagerOutcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ManagerOutcome): ManagerOutcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_outcome */ 1:
                    message.isOutcome = reader.bool();
                    break;
                case /* repeated c1.api.analysis.v1.ManagerData managers */ 2:
                    message.managers.push(ManagerData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.analysis.v1.ManagerData most_relevant */ 3:
                    message.mostRelevant.push(ManagerData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ManagerOutcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_outcome = 1; */
        if (message.isOutcome !== false)
            writer.tag(1, WireType.Varint).bool(message.isOutcome);
        /* repeated c1.api.analysis.v1.ManagerData managers = 2; */
        for (let i = 0; i < message.managers.length; i++)
            ManagerData.internalBinaryWrite(message.managers[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.analysis.v1.ManagerData most_relevant = 3; */
        for (let i = 0; i < message.mostRelevant.length; i++)
            ManagerData.internalBinaryWrite(message.mostRelevant[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.ManagerOutcome
 */
export const ManagerOutcome = new ManagerOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessConflictOutcome$Type extends MessageType<AccessConflictOutcome> {
    constructor() {
        super("c1.api.analysis.v1.AccessConflictOutcome", [
            { no: 1, name: "is_outcome", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "monitors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessConflictData }
        ]);
    }
    create(value?: PartialMessage<AccessConflictOutcome>): AccessConflictOutcome {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isOutcome = false;
        message.monitors = [];
        if (value !== undefined)
            reflectionMergePartial<AccessConflictOutcome>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessConflictOutcome): AccessConflictOutcome {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_outcome */ 1:
                    message.isOutcome = reader.bool();
                    break;
                case /* repeated c1.api.analysis.v1.AccessConflictData monitors */ 2:
                    message.monitors.push(AccessConflictData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessConflictOutcome, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_outcome = 1; */
        if (message.isOutcome !== false)
            writer.tag(1, WireType.Varint).bool(message.isOutcome);
        /* repeated c1.api.analysis.v1.AccessConflictData monitors = 2; */
        for (let i = 0; i < message.monitors.length; i++)
            AccessConflictData.internalBinaryWrite(message.monitors[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.AccessConflictOutcome
 */
export const AccessConflictOutcome = new AccessConflictOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessConflictData$Type extends MessageType<AccessConflictData> {
    constructor() {
        super("c1.api.analysis.v1.AccessConflictData", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "monitor_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessConflictData>): AccessConflictData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.monitorId = "";
        message.monitorDisplayName = "";
        if (value !== undefined)
            reflectionMergePartial<AccessConflictData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessConflictData): AccessConflictData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string monitor_id */ 1:
                    message.monitorId = reader.string();
                    break;
                case /* string monitor_display_name */ 2:
                    message.monitorDisplayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessConflictData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string monitor_id = 1; */
        if (message.monitorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.monitorId);
        /* string monitor_display_name = 2; */
        if (message.monitorDisplayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.monitorDisplayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.AccessConflictData
 */
export const AccessConflictData = new AccessConflictData$Type();
/**
 * @generated ServiceType for protobuf service c1.api.analysis.v1.AnalysisService
 */
export const AnalysisService = new ServiceType("c1.api.analysis.v1.AnalysisService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: AnalysisServiceGetRequest, O: AnalysisServiceGetResponse }
]);
